import { useCSS } from './use-css';

// Hides the ZenDesk help button in lower left of page
export function useHideZendeskButton() {
  useCSS(
    'iframe#launcher[title*="more information"] { display: none !important; }'
  );
}
